import axios from "axios";
import { useEffect, useRef, useState } from "react";
import { Link } from "react-router-dom";
import { DASHBOARD_ROUTE } from "../../../../routes";
import authServices from "../../../../services/authServices";
import dataProvider from "../../../../services/dataProvider";
import DataTable from "../../common/data-table/data-table";
import PDFZipDownload from "../../common/pdf-zip-downloader";
import { FRONT_DESK_FORM } from "../../dashboard-routes";
import frontDeskFormMap from "./front-desk-form-map";
import FrontDeskPdfGenerator from "./front-desk-pdf-generator";

const FrontDeskSubmittedForms = () => {
    const [tableHeader, setTableHeader] = useState([
        { name: "", key: "selected" },
        { name: "From Name", key: "formTitle" },
        { name: "Description", key: "description" },
        // { name: "Download Form", key: "downloadForm" },
    ]);
    const [tableData, setTableData] = useState([]);
    const [isFetching, setIsFetching] = useState(true);
    const [taskLoading, setTaskLoading] = useState(false);
    const [isDownloading, setIsDownloading] = useState(false);
    const [searchText, setSearchText] = useState("");
    const [errorMsg, setErrorMsg] = useState("");
    const [allRawFormData, setAllRawFormData] = useState([]);
    const [selectedRows, setSelectedRows] = useState([]);

    function parseData(data={}) {
        let allFormData = [];
        //console.log(data);
        Object.keys(data).forEach((key) => {
            allFormData.push({
                formTitle: (
                    <div>
                        <Link
                            to={{
                                pathname: DASHBOARD_ROUTE + FRONT_DESK_FORM,
                                state: { 
                                    formKey: key ,
                                    editMode : true ,
                                    formState : data[key]
                                },
                            }}
                        >
                            {frontDeskFormMap[key].formTitle}
                        </Link>
                    </div>
                ) ,
                formType : key,
                formTitleText : frontDeskFormMap[key].formTitle,
                description: frontDeskFormMap[key].formDescription.map((line,i) => <div key={i}>{line}</div>),
            });
        });

        return allFormData;
    }

    useEffect(()=>{
        let parsedData = parseData(allRawFormData);
        parsedData = parsedData.sort((a, b) => {
            if (!a.formTitleText) return 0;
            return a.formTitleText.toLowerCase() > b.formTitleText.toLowerCase()
                ? 1
                : b.formTitleText.toLowerCase() > a.formTitleText.toLowerCase()
                ? -1
                : 0;
        })
        setTableData(parsedData);
    },[allRawFormData])

    useEffect(() => {
        setIsFetching(true);
        setErrorMsg("");
        var config = {
            method: "post",
            url: dataProvider.baseUrl + "forms-getFrontdeskFormData",
            headers: {
                token: authServices.getToken(),
                orgid: authServices.getOrgId(),
                "Content-Type": "application/x-www-form-urlencoded",
            },
        };

        axios(config)
            .then(function (response) {
                setIsFetching(false);
                if(response.data.status === "success") {
                    setAllRawFormData(response.data.message) ;
                } else {
                    setErrorMsg("Unable to fetch data");
                }
            })
            .catch(function (error) {
                setIsFetching(false);
                console.error(error);
            });
    }, []);

    const temp = useRef();

    async function downloadForms() {
        setIsDownloading(true);

        let pdfTemplates = [] ;
        let names = [] ;

        // console.log(selectedRows);
        
        const keyList = selectedRows.map(f => f.formType) ;

        for(let key of keyList){
            let pdf = await FrontDeskPdfGenerator(key,frontDeskFormMap[key],allRawFormData[key]);
            pdfTemplates.push(pdf);
            names.push(frontDeskFormMap[key].formTitle)
        }

        await PDFZipDownload(pdfTemplates,names);
        setIsDownloading(false);
    }

    return (
        <div id="tasks">
            <div className="container-fluid p-0">
                <div className="d-flex align-items-center flex-row card p-4 no-radius border-0 border-bottom">
                    <div className="m-0 h5">Submitted Forms</div>
                    <div className="flex-fill"></div>
                    {isDownloading ? (
                        <button
                            type="submit"
                            form="addMemberForm"
                            className="btn btn-primary text-white d-flex align-items-center"
                            disabled={true}
                        >
                            Downloading
                            <div className="spinner-border spinner-border-sm ms-3" role="status">
                                <span className="visually-hidden">Loading...</span>
                            </div>
                        </button>
                    ) : (
                        <button 
                            onClick={downloadForms}
                            type="submit" 
                            form="addMemberForm" 
                            className="btn btn-primary text-white"
                            disabled={selectedRows.length === 0}
                        >
                            Download Forms as a ZIP file
                        </button>
                    )}
                </div>
            </div>

            <div className="container-fluid p-3 pb-0">
                <div className="card p-4 border-0">
                    <div className="d-flex align-items-center">
                        <label htmlFor="search">Search for Form : </label>
                        <div className="ms-3">
                            <input
                                value={searchText}
                                onChange={(e) => setSearchText(e.target.value)}
                                type="text"
                                placeholder="Search Form Names"
                                className="form-control"
                            />
                        </div>
                    </div>
                </div>
            </div>

            {errorMsg && (
                <div className="container-fluid py-0 mt-3 px-3">
                    <div className="alert alert-danger m-0" role="alert">
                        {errorMsg}
                    </div>
                </div>
            )}

            <div className="container-fluid p-3">
                <div className="card p-3 border-0">
                    {isFetching ? (
                        <div className="">
                            <div className="d-flex align-items-center justify-content-center">
                                <div className="me-3">Fetching Forms</div>
                                <div className="spinner-border text-primary" role="status">
                                    <span className="visually-hidden">Loading...</span>
                                </div>
                            </div>
                        </div>
                    ) : (
                        <div className="position-relative">
                            <DataTable 
                                search={searchText} 
                                header={tableHeader} 
                                rawData={tableData} 
                                paginate
                                selectable
                                setSelectedRows={setSelectedRows}
                            />

                            {taskLoading && (
                                <div
                                    className="position-absolute top-0 left-0 w-100 h-100 bg-dark"
                                    style={{ zIndex: "99", opacity: "0.1", cursor: "wait" }}
                                ></div>
                            )}
                        </div>
                    )}
                </div>
            </div>
            
            <div ref={temp}>

            </div>
        </div>
    );
};

export default FrontDeskSubmittedForms;
